export const roundToNearestThousand = (number) => {
  return Math.ceil(number / 100) * 100
}

export const roundToNearestTen = (number) => {
  return Math.ceil(number / 10) * 10
}